<div class="flex md:items-center md:justify-center min-h-screen md:bg-metro-blue">
  <!-- Contenedor principal: full width en mobile, tarjeta centrada en tablet/escritorio -->
  <div class="w-full p-3 md:max-w-md md:bg-white md:rounded-xl md:shadow-lg md:p-8 mt-12">
    <!-- Logo / Title -->
    <div class="text-center">
      <h2 class="mt-2 text-lg font-semibold tracking-wide text-metro-blue-secondary">
        {{'::ResetPassword' | abpLocalization}}
      </h2>
    </div>

    <!-- Form -->
    <form class="mt-8 space-y-4" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      
      <!-- Password -->
      <app-metro-form-input
        formControlName="password"
        [placeholder]="'::NewPassword' | abpLocalization"
        size="md"
        type="password">
      </app-metro-form-input>

      <!-- Confirm Password -->
      <div class="mt-2">
        <app-metro-form-input
          formControlName="confirmPassword"
          [placeholder]="'::ConfirmNewPassword' | abpLocalization"
          size="md"
          type="password">
        </app-metro-form-input>
      </div>

      <!-- Password Match Error -->
      <div *ngIf="resetPasswordForm.errors?.['passwordMismatch'] && resetPasswordForm.get('confirmPassword')?.touched"
           class="text-sm text-red-600 mt-1 px-1">
        {{'::PasswordConfirmationDoesNotMatch' | abpLocalization}}
      </div>

      <!-- Submit Button -->
      <app-metro-button
        class="w-full mt-4"
        variant="custom"
        [customClass]="'bg-metro-blue-secondary text-metro-secondary w-full'"
        [text]="(inProgress ? '::Saving' : '::ResetPassword') | abpLocalization"
        type="submit"
        [disabled]="resetPasswordForm.invalid || inProgress">
      </app-metro-button>
    </form>

    <!-- Back to Login -->
    <div class="mt-6 text-center text-sm text-metro-blue-secondary">
      <a routerLink="/account/login" class="hover:underline">{{'::BackToLogin' | abpLocalization}}</a>
    </div>
  </div>
</div>